import gql from "graphql-tag";

export const CHAINS_QUERY = gql`
  query Chains {
    chains {
      id
      name
      chainId
    }
  }
`;
